import {EventEmitter, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceService {

  stepChange: EventEmitter<number> = new EventEmitter<number>();

  next() {
    this.stepChange.emit(1);
  }

  back() {
    this.stepChange.emit(-1);
  }
}
